export default "__VITE_ASSET__DOI_hVW8__"